{
    "ShowHeaderRowLabel": "Koptekstrij weergeven:",
    "ShowFooterRowLabel": "Toon voettekstrij:",
    "ShowContentRowsLabel": "Inhoudsbeperking",
    "ShowSpacerRowsLabel": "Afstandsrij(en) tonen:",
    "NAME": "ReportContentRowsSettingsLanguage"
}